import { localStorageService } from '@/services/localStorage.service'

export interface LocalStorageFlag {
  set(status: boolean): void
  clear(): void
  isActive(): boolean
}

/**
 * Three-state flag: a stored `true`/`false` wins, `defaultWhenUnset` decides the absent case.
 * A thunk, so an env-derived default is read per call rather than frozen at import.
 */
export function createLocalStorageFlag(storageKey: string, defaultWhenUnset: () => boolean): LocalStorageFlag {
  return {
    set: status => localStorageService.set(storageKey, status),
    clear: () => localStorageService.clear(storageKey),
    isActive: () => localStorageService.getNullable(storageKey) ?? defaultWhenUnset(),
  }
}
